export default __webpack_public_path__ + "static/Informierte-Zustimmung-zum-Piercing-bei-Kindern-unter-16-Jahren-77fabe20e771d5a984a7c49a64cbd5e3.pdf";